import type { SVGProps } from 'react';
import * as React from 'react';
import { forwardRef, Ref } from 'react';

const SvgStakeFill = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      d="M12.008 5.38a3.376 3.376 0 0 1 5.173-2.609.374.374 0 0 1-.053.657 4.88 4.88 0 0 0-2.878 4.447c0 .11 0 .22.011.327a.375.375 0 0 1-.562.353 3.38 3.38 0 0 1-1.69-3.176M22.5 15.056a2.3 2.3 0 0 1-1.275 2.063l-.041.018-3.64 1.551a1 1 0 0 1-.112.038l-6 1.5a.8.8 0 0 1-.182.023H1.5a1.5 1.5 0 0 1-1.5-1.5V15a1.5 1.5 0 0 1 1.5-1.5h2.69l2.12-2.122a2.98 2.98 0 0 1 2.122-.878h4.693a2.625 2.625 0 0 1 2.555 3.23l3.922-.902a2.308 2.308 0 0 1 2.898 2.23m-1.5 0a.808.808 0 0 0-1.02-.778l-.028.008-6.281 1.444a.8.8 0 0 1-.168.019H10.5a.75.75 0 1 1 0-1.5h2.625a1.125 1.125 0 1 0 0-2.25H8.432a1.49 1.49 0 0 0-1.06.44L5.25 14.56v4.19h5.906l5.853-1.463 3.563-1.517a.8.8 0 0 0 .428-.713m-5.25-7.182a3.375 3.375 0 1 0 6.75 0 3.375 3.375 0 0 0-6.75 0"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgStakeFill);
export default ForwardRef;
